import * as React from 'react'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { getDayOfWeekShortName } from '@/modules/drivers/hooks/useDateHelper'

export type ScheduleHeaderItemProps = {
  dayOfWeek: number
  height: number
  width: number
}

export const ScheduleHeaderItem: React.FC<ScheduleHeaderItemProps> = ({
  dayOfWeek,
  height,
  width,
}) => {
  const { t } = useLocalize()

  return (
    <div
      className={`tw-flex tw-flex-col tw-items-center tw-justify-center ${
        dayOfWeek === 5 || dayOfWeek === 6
          ? 'tw-bg-[#FAFBFF]'
          : 'tw-bg-[#FFFFFF]'
      }`}
      style={{ width, height }}
    >
      <span className='tw-text-xs tw-text-[#1F2937] tw-pl-[2px]'>{t(getDayOfWeekShortName(dayOfWeek + 1))}</span>
    </div>
  )
}
